import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Landing } from './pages/Landing';
import { SplashScreen } from './components/SplashScreen';
export function App() {
  // Show the splash only on the first load of the session
  const [showSplash, setShowSplash] = useState<boolean>(() => {
    if (typeof window === 'undefined') return false;
    return sessionStorage.getItem('byn_splash_seen') !== 'true';
  });
  useEffect(() => {
    if (showSplash) {
      sessionStorage.setItem('byn_splash_seen', 'true');
    }
  }, [showSplash]);
  return <>
      {/* Landing is always mounted underneath — the site never blocks on the splash */}
      <motion.div initial={showSplash ? {
      opacity: 0,
      scale: 1.04
    } : false} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.8,
      ease: 'easeOut',
      delay: showSplash ? 0.2 : 0
    }} data-id="element-0">
        <Landing data-id="element-1" />
      </motion.div>

      <AnimatePresence data-id="element-2">
        {showSplash && <SplashScreen onComplete={() => setShowSplash(false)} data-id="element-3" />}
      </AnimatePresence>
    </>;
}